var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  viewBox: "0 0 60 60",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M8.571 51.429V60H4.315C2.032 60 .168 58.244.011 56.019L0 53.876v-2.447zm12.858 0V60h-8.572v-8.571zm12.857 0V60h-8.572v-8.571zm12.857 0V60H38.57v-8.571zm12.857 0v4.59A4.31 4.31 0 0 1 55.685 60h-4.256v-8.571zm0-12.858v8.572h-8.571V38.57zm-51.429 0v8.572H0V38.57zm38.572 0v8.572H38.57V38.57zm-12.857 0v8.572h-8.572V38.57zm-12.857 0v8.572h-8.572V38.57zM8.57 25.714v8.572H0v-8.572zM0 4.284C0 1.903 1.932 0 4.315 0h51.37C58.072 0 60 1.918 60 4.285v17.144H0zm60 21.43v8.572h-8.571v-8.572zm-12.857 0v8.572H38.57v-8.572zm-12.857 0v8.572h-8.572v-8.572zm-12.857 0v8.572h-8.572v-8.572z"
})));
export default SvgChannelCalendar;